<template>
  <TrfSimpleModal
    customStyleBody="overflow:auto;"
    :isAtivo="isAberto"
    :titulo="titulo"
    :isModalPersonalizado="true"
    :isScrollPersonalizado="true"
    @close="onClose"
  >
  <div v-if="ativarLoader" class="trf-wizard-transicao">
    <TrfGlobalLoader type="overlay" />
  </div>
    <div class="p-4" style="max-height: 95vh; max-width: 1024px; width: 100%">
      <div class="trf-wizard trf-wizard-conteudo" :data-etapa="etapaAtual">
          <div id=" trf-wizard-etapa-1" v-if="etapaAtual == 1">
            <div class="content px-4">
              <p>
                Vamos dar início a importaçao das suas tarefas. Mas antes de continuar, preciso te
                passar algumas informações importantes:
              </p>

              <p>
                Os departamentos listados no arquivo a ser importado precisam estar no mesmo padrão
                dos departamentos cadastrados na sua base.
              </p>
              <p>Acesse o link abaixo e consulte todos os departamentos que a sua base possui.</p>

              <ul class="pl-6">
                <li>
                  <strong
                    ><a target="_blank" :href="`//${urlDepartamentosEcontador}`"
                      >Lista de departamentos</a
                    ></strong
                  >
                </li>
              </ul>

              <div id="dados-obrigatorios">
                <p>Alguns dados são obrigatórios e precisam ser informados. São eles:</p>
                <ul class="pl-6">
                  <li v-for="(campoObrigatorio, index) in camposObrigatorios" :key="index">
                    <strong>{{ campoObrigatorio }}</strong>
                  </li>
                </ul>
              </div>

              <div class="pl-6">
                <p class="mt-2 mb-1">
                  OBS: Caso o seu arquivo possua a coluna "Vinculação" e a mesma estiver preenchida,
                  o campo "A partir de" precisa ser informado.
                </p>
                <p>
                  Para saber mais
                  <a
                    target="_blank"
                    href="https://ajuda.alterdata.com.br/display/PackUpBase/eTarefas+-+Como+Importar+Tarefas+a+partir+da+Planilha+em+Excel+%28.xls%29"
                    >clique aqui</a
                  >.
                </p>
              </div>

              <p class="mt-4">O arquivo precisa estar em formato .CSV ou .XLSX.</p>

              <div id="importacao">
                <p class="mb-2">Pronto para seguir com a importação?</p>
                <p class="mb-2">Clique no botão abaixo para selecionar o arquivo.</p>

                <div class="my-3 pb-1">
                  <label class="checkbox">
                    <input id="ignorar-cabecalho" type="checkbox" v-model="ignorarCabecalho" />
                    <span for="ignorar-cabecalho" class="ml-2"
                      >Ignorar primeira linha ao importar</span
                    >
                  </label>
                  <span class="tip-label is-size-7"
                    >Ao marcar esta opção, a primeira linha do excel deverá ser ignorada, pois
                    trata-se de um cabeçalho</span
                  >
                </div>

                <TrfButtonUpload
                  name="Importar tarefas"
                  customButtonStyle="min-width:140px;border-bottom-left-radius:0;border-top-left-radius:0; margin-bottom:20px"
                  extensoesPermitidas=".xlsx,.csv"
                  @uploadFile="uploadArquivoComTarefasParaPreview($event)"
                />
              </div>
            </div>
          </div>

          <div
            id="trf-wizard-etapa-2"
            data-etapa="2"
            v-if="etapaAtual == 2"
          >
              <TrfWizardModuloConfiguracaoTarefas
                :dadosTarefas="tarefasAConfigurar"
                :opcoesCabecalhosSelect="opcoesSelect"
                :valueOpcoes="valuesSelect"
                @change="verificarOpcaoSelecionadaEAlterarObrigatoriedade"
              />
          </div>

          <div
            id="trf-wizard-etapa-3"
            data-etapa="3"
            v-if="etapaAtual == 3"
          >
            <div id="tarefas-nao-cadastradas" class="content px-4">
              <p>
                As tarefas listadas abaixo não foram cadastradas, pois alguns dados informados no
                arquivo não foram identificados pelo sistema.
              </p>
              <ul class="pl-6">
                <li v-for="(tarefa, index) in tarefasNaoCadastradas" :key="index">
                  <strong>{{ tarefa }}</strong>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

    <template v-slot:slot-footer>
      <div>
        <button v-if="etapaAtual == 1" class="button" @click="() => onClose(false)">
          Cancelar
        </button>
        <button
          v-if="etapaAtual == 2"
          class="button is-primary"
          :class="{ 'is-loading': ativarLoader }"
          @click="uploadArquivoECabecalhosConfigurados"
        >
          Concluir
        </button>
        <button v-if="etapaAtual == 3" class="button" @click="() => onClose(true)">
          Fechar
        </button>
      </div>
    </template>
  </TrfSimpleModal>
</template>

<script>
import TrfSimpleModal from "../../../../components/Modal/TrfSimpleModal";
import TrfGlobalLoader from "../../../../components/GlobalLoader";
import TrfWizardModuloConfiguracaoTarefas from "./TrfWizardModuloConfiguracaoTarefas.vue";
import TrfButtonUpload from "../../../../components/ButtonUpload";
import { env } from "../../../../env";
import { uploadDeTarefasService } from "../../service/upload-tarefas-service.js";
import { toastUtils } from "../../../../util/toast.utils";

export default {
  name: "TrfWizardImportacaoDeTarefas",
  components: {
    TrfSimpleModal,
    TrfGlobalLoader,
    TrfWizardModuloConfiguracaoTarefas,
    TrfButtonUpload,
  },
  emits: ['close'],
  props: {
    utilizarTransicao: {
      type: Boolean,
      default: false,
      required: false,
    },
    isAberto: {
      type: Boolean,
      default: false,
      required: false,
    },
    opcoesSelect: Object,
    valuesSelect: Object
  },
  data() {
    return {
      titulo: "Importar tarefa",
      camposObrigatorios: [
        "Nome da tarefa",
        "Departamento",
        "Recorrência da tarefa",
        "Competência",
        "Prazo de entrega final",
        "Tipo do prazo de entrega final(útil ou fixo)",
        "Prazo de entrega legal",
        "Tipo do prazo de entrega legal(útil ou fixo)",
      ],
      urlDepartamentosEcontador: `${env.econtadorFront}/DepartamentoPackCrm/Listar`,
      arquivoSelecionado: null,
      tarefasAConfigurar: {},
      tarefasNaoCadastradas: {},
      etapaAtual: 1,
      selectedHeadings: {
        cabecalhos: [],
      },
      ativarLoader: false,
      ignorarCabecalho: false, 
    };
  },
  methods: {
    async uploadArquivoComTarefasParaPreview(e) {
      this.arquivoSelecionado = e.target.files[0];
      this.ativarLoader = true;
      try {
        if (this.isExtensaoValida()) {
          await this.uploadArquivoParaPreview();
          this._executarProximo();
        } else {
          toastUtils.dangerToast(
            "O arquivo selecionado não é válido. Por favor, selecione um arquivo válido."
          );
          this.arquivoSelecionado = e.target.value = "";
        }
      } catch (e) {
        toastUtils.dangerToast(
          "Ocorreu um erro ao carregar o arquivo. Tente novamente mais tarde."
        );
      } finally {
        this.ativarLoader = false;
      }
    },

    async uploadArquivoParaPreview() {
      const fd = new FormData();
      fd.append("file", this.arquivoSelecionado);
      fd.append("ignorarCabecalho" , this.ignorarCabecalho)
      this.tarefasAConfigurar = await uploadDeTarefasService.planilhaPreview(fd);
    },

    isExtensaoValida() {
      const extensaoArquivoEnviado = "." + this.arquivoSelecionado.name.split(".").pop();
      const extensoesPermitidas = [".xlsx", ".csv"];
      return extensoesPermitidas.find(
        (extensao) => extensaoArquivoEnviado.toLowerCase() == extensao.toLowerCase()
      );
    },

    _executarProximo() {
      this.etapaAtual += 1;
      return this.etapaAtual;
    },

    async uploadArquivoECabecalhosConfigurados() {
      this.ativarLoader = true;
      try {
        this.obterCabecalhosRelacionadosNasColunasEMontarObjetoComOSeuIndex();
        if (!this.validarSeTodosOsCabecalhosObrigatoriosForamSelecionados()) {
          this.ativarLoader = false;
          return;
        }

        const response = await this.uploadArquivoECabecalhos();
        this.verificarEExibirToastDeAcordoComOStatusDaResposta(response);
      } catch (e) {
        toastUtils.dangerToast("Ocorreu um erro ao criar as tarefas. Tente novamente mais tarde.");
        this.recarregarPaginaEDesativarLoader();
      } finally {
        this.ignorarCabecalho = false;
      }
    },

    verificarEExibirToastDeAcordoComOStatusDaResposta(response) {
      if (response?.status == 207) {
        this.tarefasNaoCadastradas = response.tarefas;
        this.exibirTarefasNaoCadastradas();
      } else if (response?.status == 400) {
        this.tarefasNaoCadastradas = response.tarefas;
        this.exibirTarefasNaoCadastradas();
      } else {
        this.recarregarPaginaEDesativarLoader();
      }
    },

    async uploadArquivoECabecalhos() {
      const fd = new FormData();
      fd.append("file", this.arquivoSelecionado);
      fd.append(
        "cabecalhos",
        new Blob([JSON.stringify(this.selectedHeadings)], { type: "application/json" })
      );
      fd.append("ignorarCabecalho" , this.ignorarCabecalho);
      return await uploadDeTarefasService.cabecalhosConfigurados(fd);
    },

    recarregarPaginaEDesativarLoader() {
      setTimeout(() => {
        window.location.reload(true);
        this.ativarLoader = false;
        this.arquivoSelecionado = "";
      }, 2000);
    },

    exibirTarefasNaoCadastradas() {
      if (this.tarefasNaoCadastradas.length > 0) {
        setTimeout(() => {
          this._executarProximo();
          this.ativarLoader = false;
        }, 2000);
      }
    },

    obterCabecalhosRelacionadosNasColunasEMontarObjetoComOSeuIndex() {
      const selectHeadingsElements = document.querySelectorAll("th select");
      this.selectedHeadings.cabecalhos = [];
      selectHeadingsElements.forEach((selectHeading, index) => {
        const value = selectHeading.value;
        this.selectedHeadings.cabecalhos.push(value);
      });
    },

    validarSeTodosOsCabecalhosObrigatoriosForamSelecionados() {
      if (this.isColunasVazias()) {
        toastUtils.dangerToast(
          "Existem colunas que não foram relacionadas. Para prosseguir, relacione as colunas com as opções disponíveis"
        );
        return false;
      }
      if (this.isCabecalhoVinculacaoSelecionadoECabecalhoAPartirDeNao()) {
        toastUtils.dangerToast(
          "A coluna 'A partir de' precisa ser relacionada para que possamos prosseguir com a importação das tarefas"
        );
        return false;
      }
      if (!this.isTodosOsCabecalhosObrigatoriosSelecionados()) {
        toastUtils.dangerToast(
          "Não foi possível prosseguir com a importação, pois existem campos obrigatórios que não foram relacionados as colunas"
        );
        return false;
      }

      return true;
    },

    isColunasVazias() {
      const cabecalhosSelecionados = this.selectedHeadings.cabecalhos;
      const isColunasVazias = cabecalhosSelecionados.some((cabecalho) => cabecalho === "");
      return isColunasVazias;
    },

    isCabecalhoVinculacaoSelecionadoECabecalhoAPartirDeNao() {
      return (
        this.isCabecalhoSelecionado("Vinculação") && !this.isCabecalhoSelecionado("A partir de")
      );
    },

    isCabecalhoSelecionado(cabecalho) {
      const cabecalhosSelecionados = this.selectedHeadings.cabecalhos;
      const isCabecalhoSelecionado = cabecalhosSelecionados.includes(cabecalho);
      return isCabecalhoSelecionado;
    },

    isTodosOsCabecalhosObrigatoriosSelecionados() {
      const cabecalhosSelecionados = this.selectedHeadings.cabecalhos;
      this.alterarObrigatoriedadeDoCabecalhoAPartirDe(
        "A partir de",
        this.isCabecalhoSelecionado("Vinculação")
      );
      const cabecalhosObrigatorios = this.cabecalhosObrigatorios();
      const isTodosOsCabecalhosObrigatoriosSelecionados = cabecalhosObrigatorios.every((option) =>
        cabecalhosSelecionados.includes(option.label)
      );
      return isTodosOsCabecalhosObrigatoriosSelecionados;
    },

    verificarOpcaoSelecionadaEAlterarObrigatoriedade(value) {
      const cabecalhoSelecionado = value;
      if (cabecalhoSelecionado == "Vinculação") {
        this.alterarObrigatoriedadeDoCabecalhoAPartirDe("Vinculação", "A partir de", true);
      }
    },

    alterarObrigatoriedadeDoCabecalhoAPartirDe(cabecalhoASerAlterado, isObrigatorio) {
      const cabecalhoASerAlteradoIndex = this.opcoesSelect.findIndex(
        (header) => header.label === cabecalhoASerAlterado
      );
      const cabecalhoASerAlteradoHeader = this.opcoesSelect[cabecalhoASerAlteradoIndex];
      cabecalhoASerAlteradoHeader.required = isObrigatorio;
    },

    cabecalhosObrigatorios() {
      return this.opcoesSelect.filter((header) => header.required);
    },

    onClose(reload = false) {
      this.ignorarCabecalho = false;
      this.$emit('close', reload);
    }
  },
  watch: {
    isAberto(valorNovo, valorVelho) {
      if (valorNovo != valorVelho) {
        this.etapaAtual = 1;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../../assets/sass/variables.scss";
ul li a {
  color: $color-primary;
}

label {
  font-weight: normal;
}
.tip-label {
  color: #4a4a4a;
  display: block;
}
</style>